module.exports = __webpack_public_path__ + "img/bespoke123_14.7bb17fc9.jpg";